// Checkout step 6 "Danke" (Figma 64637:37033, "CHECKOUT | 06 Danke | Desktop") — a real routed
// page, not a modal. Reached only via history.push('/checkout/danke', { mainImageTransparent,
// email }) from OfferRequestButtonWrapper.tsx's showCongratulations (isOverview branch, i.e. the
// actual order-overview "Jetzt kaufen" submit) — NOT part of checkoutStore.steps (no stepper
// dot, doesn't count toward any step's "Schritt X von Y", not gated by stepHasError/completed),
// since the order is already placed by the time this renders.
//
// Chrome is its own, deliberately simple header (Figma's "Checkout Header Desktop" — just the
// logo), not CheckoutTopBarNext/CheckoutHeaderNext/CheckoutAsideNext — those are for the 5
// in-progress steps (car price/stepper/back-to-previous-step) and don't apply once the order is
// placed. Footer is the same site-wide Footer every non-checkout page uses (App.tsx suppresses
// its own top-level one for any /checkout path — see isCheckout there — so, same as
// CheckoutPage.tsx does for ModalOverlay, this renders its own copy).
import * as React from 'react';
import { translate } from 'react-i18next';
import { Footer } from '@bytebrand/fe-ui-core-autobahn/chrome';
import logoUrl from '@bytebrand/fe-ui-core-autobahn/assets/autode-logo.svg';
import Page from '../../containers/Page';
import Congratulations from './Modals/Congratulations';
const CheckoutThankYouPage = ({ t, location }) => {
    const { mainImageTransparent, email } = (location && location.state) || {};
    // Page's mainContentClass ("cgz-main-content", md3.css) escapes MainContent.styl's default
    // `container()` mixin (max-width: 1100px, centered) — the same 1100px-boxed-with-gray-gutters
    // look CheckoutPage.tsx itself escapes via its own mainContentWrap (App.tsx wraps every
    // non-SPA-layout route, /checkout included, in <MainContent> regardless of what the routed
    // page itself renders — a plain unwrapped div here still inherits that cap).
    return (React.createElement(Page, { page: "CHECKOUT_THANK_YOU_PAGE", showCrumbs: false, mainContentClass: "cgz-main-content" },
        React.createElement("div", { className: "md3 cgz-page" },
            React.createElement("header", { className: "cgz-page-header" },
                React.createElement("a", { href: "/", "aria-label": "auto.de" },
                    React.createElement("img", { src: logoUrl, alt: "auto.de", className: "cgz-page-logo" }))),
            React.createElement("main", { className: "cgz-page-main" },
                React.createElement(Congratulations, { t: t, mainImageTransparent: mainImageTransparent, email: email })),
            React.createElement(Footer, { t: t, showCostFootnotes: false, hideBrandColumns: true }))));
};
export default translate(['CheckoutPage'])(CheckoutThankYouPage);
